import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getJourneyGraphSuccess,
  getJourneyGraphFailure,
  saveJourneyGraphSuccess,
  saveJourneyGraphFailure,
  publishJourneyGraphSuccess,
  publishJourneyGraphFailure,
  validateJourneyGraphSuccess,
  validateJourneyGraphFailure,
} from "./actions";
import {
  GET_JOURNEY_GRAPH,
  SAVE_JOURNEY_GRAPH,
  PUBLISH_JOURNEY_GRAPH,
  VALIDATE_JOURNEY_GRAPH,
} from "./constants";

export function* getJourneyGraphSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${locationId}/journey-graph`,
    );
    yield put(getJourneyGraphSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getJourneyGraphFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to load journey graph"));
  }
}

export function* saveJourneyGraphSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location/${locationId}/journey-graph`,
      formData,
    );
    yield put(saveJourneyGraphSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(successAlert("Draft saved"));
  } catch (e) {
    yield put(saveJourneyGraphFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to save draft"));
  }
}

export function* publishJourneyGraphSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, graphUuid } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/location/${locationId}/journey-graph/${graphUuid}/publish`,
    );
    yield put(publishJourneyGraphSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    yield put(
      successAlert(
        `Published. Recomputing pathways for ${data?.data?.recomputed_for ?? "all"} residents.`,
      ),
    );
  } catch (e) {
    const issues = e?.data?.issues ?? e?.issues ?? [];
    const message =
      typeof e === "string"
        ? e
        : (e?.error ?? e?.message ?? "Failed to publish");
    yield put(publishJourneyGraphFailure({ issues, message }));
    yield put(errorAlert(message));
  }
}

export function* validateJourneyGraphSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, graphUuid } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${locationId}/journey-graph/${graphUuid}/validate`,
    );
    yield put(validateJourneyGraphSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(validateJourneyGraphFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to validate graph"));
  }
}

export default function* LocationJourneyGraphSaga() {
  yield all([
    takeEvery(GET_JOURNEY_GRAPH, getJourneyGraphSaga),
    takeEvery(SAVE_JOURNEY_GRAPH, saveJourneyGraphSaga),
    takeEvery(PUBLISH_JOURNEY_GRAPH, publishJourneyGraphSaga),
    takeEvery(VALIDATE_JOURNEY_GRAPH, validateJourneyGraphSaga),
  ]);
}
